export default {
  about: "About",
  courses: "Courses",
  pricing: "Pricing",
  blog: "Blog",
  contact: "Contact",
};
